<template>
  <div class="export-data" :ef-feature-id="setEfFeatureId ?`export-menu-btn-${chartObj.key}` : false">
    <v-menu content-class="export-data--menu" top left offset-x open-on-hover>
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-icon>more_horiz</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-tile
          class="tile"
          v-for="(item, i) in chartObj.exportTo"
          :key="i"
          @click="exportData(item)">
          <v-list-tile-title :ef-feature-id="setEfFeatureId ?`export-${item}-${chartObj.key}` : false">
            {{ item.toUpperCase() }}
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import FileSaver from 'file-saver'

export default {
  name: 'ExportChartMenu',
  props: {
    chartObj: { type: Object, required: true },
    comparisonPeriod: { type: Boolean, required: false },
    dateTimeComparison: { type: Array, required: false },
    setEfFeatureId: { type: Boolean, required: false }
  },
  data () {
    return {}
  },
  computed: {},
  mounted () {},
  methods: {
    ...mapActions(['exportTableData']),
    exportData (format) {
      let pagination = { ...this.chartObj.pagination }
      delete pagination['page']
      let exportPayload = {
        key: this.chartObj.key,
        filters: this.$store.getters.isGenericGen ? this.$store.getters.selectedFiltersGen : this.$store.getters.selectedFilters,
        pagination,
        format: format,
        exportDetailed: this.chartObj.exportDetailed
      }
      if (this.comparisonPeriod) {
        exportPayload.date_time_comparison = this.dateTimeComparison
      }

      this.exportTableData(exportPayload).then(data => {
        FileSaver.saveAs(data, `${this.chartObj.title.replace(/ /g, '_')}.${format}`)
      }).catch(error => {
        this.$log.info('Download error: ', error)
        this.$store.commit('SET_SNACKBAR_TEXT', 'table.export.error-message')
        this.$store.commit('SET_SNACKBAR', true)
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .export-data {
    .v-btn--icon {
      border: 1px solid white;
      background-color: rgb(217, 217, 217);
      color: #015eab;
      border-radius: 3px;
      width: 30px;
      height: 30px;
      &:hover {
        color: #015eab;
        background-color: rgb(163, 163, 163);
      }
      &:before {
        border-radius: 3px;
        background-color: rgb(217, 217, 217);
      }
      .v-icon {
        font-size: 12px;
      }
    }
    &--menu {
      -webkit-box-shadow: none;
      box-shadow: none;
      background: rgba(255, 255, 255, 0);
      .v-list {
        padding: 0;
        .tile {
          border-top: 1px solid white;
          border-radius: 3px;
          color: #015eab;
          background-color: rgb(217, 217, 217);
          &:hover {
            color: #015eab;
            background-color: rgb(163, 163, 163);
          }
          .v-list__tile__title {
            font-size: 14px;
            text-align: center;
          }
        }
      }
    }
  }
</style>
